import * as React from 'react';
import { HiMiniSquare3Stack3D } from "react-icons/hi2";
import { GrGroup } from "react-icons/gr";
import { IoIosPricetags } from "react-icons/io";
import { MdAddchart } from "react-icons/md";
import { IoPencil, IoTrashOutline, IoSearchOutline } from "react-icons/io5";
import { getAllProject, logout } from '../../../service/service-call';
import AddProjects from './projectAdd';
import ProjectDelete from './projectDelete';
import EditProjects from './projectEdit';
import ViewProjects from './projectView';

export default function Projects() {
  const [searchText, setSearchText] = React.useState("");
  const [isViewProjectOpen, setIsViewProjectOpen] = React.useState(false);
  const [isAddProjectOpen, setIsAddProjectOpen] = React.useState(false);
  const [isEditProjectOpen, setIsEditProjectOpen] = React.useState(false);
  const [isDeleteProjectOpen, setIsDeleteProjectOpen] = React.useState(false);
  const [members, setProjects] = React.useState([]);
  const [selectedProjects, setSelectedProjects] = React.useState({});
  const [selectedProjectId, setSelectedProjectId] = React.useState("");
  const [selectedProjectName, setSelectedProjectName] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    getAllProjectByUser(searchText);
  }, []);

  function toggleAddProjectModal() {
    setIsAddProjectOpen(!isAddProjectOpen);
    if (isAddProjectOpen === true) {
      getAllProjectByUser(searchText);
    }
  }

  function editProject(id) {
    setSelectedProjectId(id);
    toggleEditProjectModal();
  }

  function deleteProject(id, name) {
    setSelectedProjectId(id);
    setSelectedProjectName(name);
    toggleDeleteProjectModal();
  }

  function toggleEditProjectModal() {
    setIsEditProjectOpen(!isEditProjectOpen);
    if (isEditProjectOpen === true) {
      getAllProjectByUser(searchText);
    }
  }

  function toggleDeleteProjectModal() {
    setIsDeleteProjectOpen(!isDeleteProjectOpen);
    if (isDeleteProjectOpen === true) {
      getAllProjectByUser("");
    }
  }

  function toggleViewProjectModal(each) {
    console.log(each);
    setSelectedProjects(each);
    setIsViewProjectOpen(!isViewProjectOpen);
  }

  function getAllProjectByUser(value) {
    setIsLoading(true);
    getAllProject(value).then(resp => {
      setIsLoading(false);
      if (resp.status === 401) {
        logout();
      }
      resp.json().then(data => {
        setProjects(data);
      });
    }).catch(error => {
      console.log("login user err " + error);
    });
  }

  const role = localStorage.getItem("role");

  return (
    <div>
      {/* Toolbar */}
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <div className="relative w-full max-w-xs">
          <IoSearchOutline size={16} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            value={searchText}
            placeholder="Search project here.."
            onChange={(e) => {
              setSearchText(e.target.value);
              getAllProjectByUser(e.target.value);
            }}
            className="w-full rounded-lg border border-gray-200 bg-white py-2 pl-9 pr-3 text-sm text-gray-700 outline-none transition-colors focus:border-[#262673] focus:ring-2 focus:ring-[#262673]/10"
          />
        </div>

        {role !== "ROLE_USER" && (
          <button
            onClick={toggleAddProjectModal}
            title="Add Project"
            className="flex h-11 w-11 items-center justify-center rounded-full bg-[#262673] text-white shadow-lg shadow-[#262673]/30 transition-all duration-300 hover:-translate-y-1 hover:scale-110 hover:bg-orange-500 hover:shadow-orange-500/30"
          >
            <MdAddchart size={18} />
          </button>
        )}
      </div>

      {/* Loading */}
      {isLoading && (
        <div className="flex items-center justify-center py-10">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-[#262673]" />
        </div>
      )}

      {/* Project grid */}
      {!isLoading && (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
          {members && members.length > 0 ? (
            members.map((each, ind) => {
              const isActive = each.status === "ACTIVE";
              return (
                <div
                  key={ind}
                  className="flex flex-col rounded-2xl border border-gray-100 bg-white p-4 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-[#262673]/10 hover:shadow-lg"
                >
                  <div className="flex items-start justify-between gap-2">
                    <button onClick={() => toggleViewProjectModal(each)} className="flex flex-1 items-start gap-3 text-left">
                      <div title={isActive ? "Project is ACTIVE" : "Project is INACTIVE"} className="shrink-0 pt-0.5">
                        <HiMiniSquare3Stack3D size={32} color={isActive ? "#16a34a" : "#ef4444"} />
                      </div>
                      <div className="min-w-0 flex-1">
                        <p className="truncate text-sm font-bold text-[#262673]">{each.projectName}</p>
                        <p className="mt-0.5 line-clamp-2 text-xs text-gray-400">
                          {each.description}
                        </p>
                      </div>
                    </button>

                    {role !== "ROLE_USER" && (
                      <div className="flex shrink-0 gap-0.5">
                        <button
                          onClick={() => editProject(each.id)}
                          title="Edit"
                          className="flex h-7 w-7 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-green-50 hover:text-green-600"
                        >
                          <IoPencil size={13} />
                        </button>
                        {role === "ROLE_SUPER_ADMIN" && (
                          <button
                            onClick={() => deleteProject(each.id, each.projectName)}
                            title="Delete"
                            className="flex h-7 w-7 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-red-50 hover:text-red-500"
                          >
                            <IoTrashOutline size={13} />
                          </button>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Tags */}
                  {each.tags && each.tags.length > 0 && (
                    <div className="mt-3 flex flex-wrap gap-1.5">
                      {each.tags.map((t, i) => (
                        <span
                          key={i}
                          className="flex items-center gap-1 rounded-md border border-gray-200 px-2 py-0.5 text-[11px] font-medium text-[#262673]"
                        >
                          <IoIosPricetags size={10} />
                          {t.name}
                        </span>
                      ))}
                    </div>
                  )}

                  {/* Teams */}
                  {each.teams && each.teams.length > 0 && (
                    <div className="mt-2 flex flex-wrap gap-1.5">
                      {each.teams.map((t, i) => (
                        <span
                          key={i}
                          className="flex items-center gap-1 rounded-md bg-[#262673] px-2 py-0.5 text-[11px] font-medium text-white"
                        >
                          <GrGroup size={10} />
                          {t.teamName}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <div className="col-span-full flex flex-col items-center justify-center gap-2 rounded-2xl border border-dashed border-gray-200 py-16 text-gray-400">
              <MdAddchart size={26} className="text-gray-300" />
              <p className="text-sm font-medium">No projects found</p>
            </div>
          )}
        </div>
      )}

      {/* Add project modal */}
      {isAddProjectOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
          <div className="w-full max-w-[420px] overflow-hidden rounded-2xl bg-white shadow-2xl">
            <AddProjects addProjectsModal={toggleAddProjectModal} />
          </div>
        </div>
      )}

      {/* Edit project modal */}
      {isEditProjectOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
          <div className="w-full max-w-[420px] overflow-hidden rounded-2xl bg-white shadow-2xl">
            <EditProjects editProjectModal={toggleEditProjectModal} selectedProjectId={selectedProjectId} />
          </div>
        </div>
      )}

      {/* View project modal — wider */}
      {isViewProjectOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
          <div className="w-full max-w-[560px] overflow-hidden rounded-2xl bg-white shadow-2xl">
            <ViewProjects viewProjectModal={toggleViewProjectModal} project={selectedProjects} />
          </div>
        </div>
      )}

      {/* Delete project modal */}
      {isDeleteProjectOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
          <div className="w-full max-w-[420px] overflow-hidden rounded-2xl bg-white shadow-2xl">
            <ProjectDelete deleteProjectsModal={toggleDeleteProjectModal} projectId={selectedProjectId} name={selectedProjectName} />
          </div>
        </div>
      )}
    </div>
  );
}